export default "__VITE_ASSET__CzUWr$Ix__"